export default __webpack_public_path__ + "static/media/AZ.a12fa7e0.svg";